import { Store } from '@tanstack/react-store'

export type DocumentsListFilter = {
  removed?: string
  style?: string
}

export const defaultDocumentsFilter: DocumentsListFilter = {
  removed: 'false',
  style: undefined,
}

export type DocumentsListState = {
  filter: DocumentsListFilter
}

export const defaultDocumentsListState: DocumentsListState = {
  filter: defaultDocumentsFilter,
}

export const documentsListStore = new Store(defaultDocumentsListState)

export const resetDocumentsList = () => {
  documentsListStore.setState(defaultDocumentsListState)
}
